import { render } from "./AdminAddNewEmpPage.vue?vue&type=template&id=622eaeda"
import script from "./AdminAddNewEmpPage.vue?vue&type=script&lang=js"
export * from "./AdminAddNewEmpPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__